import ListFieldsGeneric from './ListFieldsGeneric'
let ListFields = ListFieldsGeneric('Veranstaltung')

export default {
  label: 'Veranstaltung',
  route: 'veranstaltung',
  className: 'veranstaltung',
  fields: [
    ListFields.SortableTimestamp('_updateDate', false, 'updateDate', true),
    ListFields.SortableTimestamp('_createDate', false, 'createDate', true),
    ListFields.SortableReference('organisationseinheit', true),
    ListFields.UnsortableReference('weitereOrganisationseinheiten', false),
    ListFields.SortableField('name', true),
    ListFields.SortableField('veranstaltungsTyp', true),
    ListFields.UnsortableReference('veranstalter', false),
    ListFields.SortableDate('veranstaltungStart', true),
    ListFields.SortableDate('veranstaltungEnde', true),
    ListFields.SortableField('stadt', false),
    ListFields.SortableReference('land', false),
    ListFields.SortableBoolean('virtuell', false)

  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/Veranstaltung.js